/**
 * Shared URLs for free-tool → authenticated transcribe handoff.
 * All free tools use the same dashboard route and query shape; job.tool comes from DB on import.
 */

export const FREE_TOOL_TRANSCRIBE_HANDOFF_PATH = '/dashboard/tools/handoff' as const;

import { buildHandoffPath } from '@engine/tools-shell';

/** Relative path: `/dashboard/tools/handoff?jobId=...&token=...` */
export function buildTranscribeHandoffPath(jobId: string, token: string): string {
  return buildHandoffPath(FREE_TOOL_TRANSCRIBE_HANDOFF_PATH, jobId, token);
}

/*
 * `buildSignUpRedirectUrl` / `buildSignInRedirectUrl` lived here and were never
 * called by anything — which is why the new-visitor handoff leaked for as long as
 * it did: the helper for the fix existed, unused, while the sign-in page dropped
 * `redirect_url` on the floor.
 *
 * They are deliberately not revived. The bounce is now decided in middleware
 * (`/dashboard/tools/handoff` → /sign-up, everything else → /sign-in) and the
 * auth pages forward the destination with `withRedirectUrl` in
 * `src/lib/auth/redirect-url.ts`, which validates without throwing. Nothing needs
 * a handoff-only URL builder.
 */
